<template>
  <v-btn @click="$emit('click')" icon rounded color="red" v-bind="$attrs" v-on="$listeners">
    <v-img src="/img/trash.svg"></v-img>
  </v-btn>
</template>

<script>
export default {
  name: "TrashIconBtn"
}
</script>

<style scoped>

</style>
